export default {
    state: {
        isActive: false,
        bodyLocked: false,
        htmlNoScroll: false,
        popup: {
            success: true,
            title: 'Что-то произошло!',
            text: 'Что именно произошло - не известно',
            button: 'Понятно',
            color: '#4663AB',
        },
    },
    mutations: {
        writeActivity: (state, value) => state.isActive = value,
        writePopup: (state, value) => state.popup = value,
        lockBody: (state, value) => state.bodyLocked = value,
        setHtmlNoScroll: (state, value) => state.htmlNoScroll = value,
    },
    actions: {
        lockBody: (ctx, value) => ctx.commit('lockBody', value),
        setHtmlScroll: (ctx, value) => ctx.commit('setHtmlNoScroll', !value),
        showPopup: (ctx, params) => {
            const checklist =
                   params.title
                && params.text
                && params.button
                && params.color;

            if ( ! checklist) return;

            document.body.style.overflowX = 'hidden';

            ctx.commit('writeActivity', true);
            ctx.commit('writePopup', params);
        },

        hidePopup: ctx => {
            ctx.commit('writeActivity', false);

            document.body.style.overflow = 'auto';
        },
    },
    getters: {
        isPopupActive: state => state.isActive,
        popup: state => state.popup,
        bodyLocked: state => state.bodyLocked,
        htmlNoScroll: state => state.htmlNoScroll,
    },
};
